import React, { Component } from 'react';
import { PnkConnect } from '../../../pnk-react/pnk-miniredux';
import OrganizerForm from './form';
import $ from 'jquery';
import AppUtils from '../../../apputils';
import { AddOrganizerData, UpdateOrganizerDetails } from '../../../models/organizers';
import { GetCategoryData } from '../../../models/category';

//import DateTimePicker from 'react-datetime-picker';

class addOrganizer extends Component {
    constructor() {
        super()
        this.state = {
            showButtonType: "Add Organizer",
            txtOrganizerName: "",
            txtOrganizerAddress: "",
            txtOrganizerMobile: "",
            txtOrganizerEmail: "",
            ddlOrganizerCategory: "",
            txtOrganizerDescription: "",
            //  txtOrganizerRating: "",
            ddlOrganizerStatus: "",
            fileOrganizerImage: "",
            actionType: 'save',
            showEditBtn: 'none',
            currentSeletedOrganizerId: '',
            editData: false,
            sendData: false,
            getCategory: true,
            categorylist: [],
            mode: 'add'
        }
        this.editDataObj = {}
        this.data = {}
    }

    HandleOrganizerInput = (e) => {

        if (document.getElementById('fileOrganizerImage').value !== undefined && document.getElementById('fileOrganizerImage').value !== '') {
            this.editDataObj['fileOrganizerImage'] = document.getElementById('fileOrganizerImage').value;
            this.setState({
                fileOrganizerImage: document.getElementById('fileOrganizerImage').value
            })
        }
        

        let val = e.target.value;
        let name = e.target.name;
       
        this.editDataObj[name] = val;
        this.setState({ [name]: val });
    }

    HideModal = () => {
        this.props.componentprops.currentAction.close();
    }

    HandleOrganizerImage = (e) => {
        this.editDataObj[e.target.name] = e.target.value;
    }
    componentDidMount = () => {
        this.ChangePageMode()
    }
    ChangePageMode = () => {
        let obj;
        //  alert(this.props.componentprops.currentAction.data)
        // console.log(JSON.stringify(this.props.componentprops.currentAction.data))
        if (this.props.componentprops.currentAction !== undefined && this.props.componentprops.currentAction.action === 'Detail') {

            this.setState({
                showEditBtn: 'block',
                mode: 'edit',
                renderChild: true,
                currentSeletedOrganizerId: this.props.componentprops.currentAction.data[0]._id
            })
            this.editDataObj = {
                txtOrganizerName: this.props.componentprops.currentAction.data[0].organizer_name,
                txtOrganizerEmail: this.props.componentprops.currentAction.data[0].organizer_email,
                txtOrganizerMobile: this.props.componentprops.currentAction.data[0].organizer_mobile,
                txtOrganizerDescription: this.props.componentprops.currentAction.data[0].organizer_desc,
                ddlOrganizerCategory: this.props.componentprops.currentAction.data[0].organizer_category,
                txtOrganizerAddress: this.props.componentprops.currentAction.data[0].organizer_addr,
                ddlOrganizerStatus: this.props.componentprops.currentAction.data[0].organizer_status,
                fileOrganizerImage: this.props.componentprops.currentAction.data[0].organizer_image,
            }

            this.setState({
                ddlOrganizerCategory: this.props.componentprops.currentAction.data[0].organizer_category
            })

            obj = {

                organizerActionHeading: 'Organizer Detail',
                editDeleteDiv: true,
                getOrganizerData: true,
                currentSeletedOrganizerId: this.props.componentprops.currentAction.data[0]._id,
                showButtonType: 'Update Organizer',
                formModeActivity: true,
                btnOrganizerOuterDiv: false,


            };
            console.log(this.editDataObj.organizer_name);
            let form = document.getElementById("frmOrganizerEntry");
            let elements = form.elements;

            for (let i = 0, len = elements.length; i < len; ++i) {
                if (elements[i].id !== '')
                    elements[i].disabled = true;
            }

        }
        else {
            obj = { formModeActivity: false, btnOrganizerOuterDiv: true, editDeleteDiv: false };
            let form = document.getElementById("frmOrganizerEntry");
            let elements = form.elements;
            for (let i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = false;
            }
        }

        this.setState(obj);
    }

    ShowEditMode = () => {

        let form = document.getElementById("frmOrganizerEntry");
        let elements = form.elements;
        for (let i = 0, len = elements.length; i < len; ++i) {
            if (elements[i].id !== "txtOrganizerEmail" && elements[i].id !== "txtOrganizerMobile") {

                elements[i].disabled = false;
                // elements[2].disabled = false;
            }
            // if (elements[i].id !== "txtOrganizerMobile") {
            //     elements[i].disabled = false;
            // }
        }

        this.setState({ formModeActivity: false, organizerActionHeading: 'Edit User', btnUserProfileOuterDiv: true, showEditBtn: 'none', actionType: 'update' })

    }

    SaveOrganizerEntryData = (e) => {
        //   alert('iiii' + JSON.stringify(e))
        //   alert(this.state.txtOrganizerName)
        this.data = {
            txtOrganizerName: e.txtOrganizerName,
            txtOrganizerMobile: e.txtOrganizerMobile,
            txtOrganizerEmail: e.txtOrganizerEmail,
            ddlOrganizerCategory: e.ddlOrganizerCategory,
            txtOrganizerDescription: e.txtOrganizerDescription,
            txtOrganizerAddress: e.txtOrganizerAddress,
            //   txtOrganizerRating: e.txtOrganizerRating,
            fileOrganizerImage: e.fileOrganizerImage,
            ddlOrganizerStatus: e.ddlOrganizerStatus
            // txtLeadSourceName: e.txtSourceName,
            // txtMailForwardTo: 'hello@neoroots.design',
            // txtDefaultAssignee: 'hello@neoroots.design',
            // ddlLeadSourceStatus: e.ddlSourceStatus,
            // imgLeadSourceImage: e.fileAdditionalAttachment,
        }
        if (this.state.actionType === 'save') {
            this.setState({
                sendData: true
            })
        }
        else {
            this.setState({
                editData: true, sendData: false
            })
        }
        //     if (this.state.actionType === 'save') {
        //         this.setState({
        //             sendData: true
        //         })
        //     }
        //     else {
        //         this.setState({
        //             editData: true, sendData: false
        //         })
        //     }


        console.log(this.data);
        console.log(this.editDataObj);
    }

    HandleGetCategoryListSuccessResponse = (res) => {
        if (res !== false) {
            console.log(JSON.stringify(res.data))
            this.setState({
                categorylist: res.data.categorieslist.rows,
                getCategory: false

            })
            console.log(this.state.categorylist)

        }

        else {
            this.setState({
                getCategory: false
            })

        }
    }


    HandleUpdateOrganizerDataSuccessResponse = (res) => {
        //  alert('jjjj')
        console.log(JSON.stringify(res));

        if (res !== false) {
            // this.props.componentprops.currentAction.organizerListUpdate = true
            this.setState({
                editData: false,
            })
            this.HideModal();
            // this.props.componentprops.handleClose();

        }
        else {
            this.setState({
                editData: false
            })
        }
    }

    HandleAddOrganizerDataSuccessResponse = (res) => {

        console.log(JSON.stringify(res));
        if (res !== false) {

            document.getElementById('spnSuccessMessageTitle').innerText = "Server Response - ";
            document.getElementById('spnSuccessMessage').innerText = res.data.addorganizerresponse.message.value;
            let that = this;
            $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
                that.HideModal();
            })

        }
        else {
            document.getElementById('spnWarningMessageTitle').innerText = "Server Response - ";
            document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;

            let that = this;
            $('#crmWarningAlert').slideDown().slideUp(3000, function () {
                that.HideModal();
            })

        }
        this.setState({ sendData: false });
    }



    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }


    render() {
        return (
            <div>
                <OrganizerForm {...this.props} HandleRouting={this.HandleRouting}
                    HandleOrganizerInput={this.HandleOrganizerInput} editDataObj={this.editDataObj}
                    mystate={this.state} HandleOrganizerImage={this.HandleOrganizerImage}
                    SaveOrganizerEntryData={this.SaveOrganizerEntryData}
                    ShowEditMode={this.ShowEditMode} categorylist={this.state.categorylist}

                />
                {((this.state.getCategory === true) ? GetCategoryData(this.props.PnkStore, this.HandleGetCategoryListSuccessResponse) : "")}
                {(this.state.sendData === true) ? AddOrganizerData(this.props.PnkStore, this.data, this.HandleAddOrganizerDataSuccessResponse) : ""}
                {(this.state.editData === true) ? UpdateOrganizerDetails(this.props.PnkStore, this.state.currentSeletedOrganizerId, this.data, this.HandleUpdateOrganizerDataSuccessResponse) : ""}
            </div>
        )
    }
}

export const AddOrganizer = PnkConnect(addOrganizer, '');
